import HacktoberFest from "../public/HacktoberFest.png";
import Web3Connect from "../public/Web3Connect.png"
export const UpcomingEventsData = [
    {
        id: 1,
        title: 'HacktoberFest',
        date: "16th October'23",
        venue: 'IIT Indore',
        bgImage:HacktoberFest
    }
]
export const PastEventsData = [
    {
        id: 1,
        title: '',
        date: '',
        venue: '',
        bgImage:Web3Connect
    },
    {
        id: 2,
        title: 'Arcade',
        date: 'July23-August23',
        venue: 'IIT Indore',
        bgImage:'https://i.ibb.co/zXKQ3zc/GC-arcade-header-images-desktop-x3-v2123.png'
    }
]